import { render, staticRenderFns } from "./InspectionTestPlanStatusPanel.vue?vue&type=template&id=6c10550c&"
import script from "./InspectionTestPlanStatusPanel.vue?vue&type=script&lang=js&"
export * from "./InspectionTestPlanStatusPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports